const especialidades = [
  'Acompanhamento Terapêutico',
  'Adoção de filhos',
  'Adolescência',
  'Agorafobia',
  'Anorexia',
  'Ansiedade',
  'Autismo',
  'Autoestima',
  'Bulimia',
  'Carreira',
  'Casais',
  'Perinatal',
  'Cirurgia Bariátrica',
  'Compulsões',
  'Conflitos Amorosos',
  'Conflitos Familiares',
  'Conflitos Legais',
  'Dependência Jogos',
  'Dependência Química',
  'Depressão',
  'Depressão Pós-parto',
  'Desenvolvimento Pessoal',
  'Disfunções Sexuais',
  'Dislexia',
  'Emagrecimento',
  'Esquizofrenia',
  'Estresse',
  'Fobias',
  'Hipocondria',
  'Idosos',
  'Insônia',
  'LGBTQI+',
  'Ludoterapia',
  'Maternidade',
  'Morte e Luto',
  'Neuropsicologia',
  'Obesidade',
  'Oncologia',
  'Pessoas com Deficiência - PCD',
  'Piromania',
  'Psicologia Infantil',
  'Sexualidade',
  'Síndrome de Burnout',
  'Síndrome do Pânico',
  'Suicídio',
  'TDA e TDAH',
  'TOC - Transtorno Obsessivo',
  'Transtorno Bipolar',
  'Transtorno da Personalidade Borderline',
  'Transtorno de Acumulação',
  'Transtorno de Ansiedade Generalizada (TAG)',
  'Violência Doméstica',
  'Violência Sexual'
]

export default especialidades